<div class="contract-modal-backdrop">
  <div
    class="contract-modal-container"
    role="dialog"
    aria-modal="true"
    aria-labelledby="contract-modal-title"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <div class="contract-modal-header">
      <span id="contract-modal-title" class="h2-title">Anteprima documento</span>
    </div>

    <div class="contract-modal-body">
      @if (isLoading()) {
        <div class="contract-modal-loading">
          <span>Caricamento in corso...</span>
        </div>
      } @else if (hasError()) {
        <div class="contract-modal-error">
          <span>Impossibile caricare il documento. Riprova più tardi.</span>
        </div>
      } @else {
        <div class="contract-modal-content" [innerHTML]="htmlContent() | safeHtml:'contract'"></div>
      }
    </div>

    <div class="contract-modal-footer">
      <button class="secondary" type="button" (click)="download()" [disabled]="isLoading() || hasError()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" width="16" height="16" aria-hidden="true">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        Scarica
      </button>
      <button class="primary" type="button" (click)="accept()">Accetta e chiudi</button>
    </div>
  </div>
</div>
